<template>
    <div>
        <cases-header :actIndex="actIndex" :imgList="imgList" :topStyle="topStyle" :logo="logo" :showback="showback"></cases-header>
        <case-detail  :casedetail="caseInfo"></case-detail>
        <cases-footer :bottom="bottom" :bottomInfo="contactInfo"></cases-footer>
    </div>
</template>

<script>
import CasesHeader from '@/components/mobile/Header'
import CaseDetail from '@/components/mobile/CaseDetail'
import CasesFooter from '@/components/mobile/Footer'
export default {
    name: 'case',
    data () {
        return {
            actIndex: 3,
            showback: false,
            topStyle: "",
            imgList: false,
            bottom: {},
            logo: '',
            contactInfo: {},
            CaseId:-1,
            caseInfo:{}
        }
    },
    components: {
        CasesHeader,
        CaseDetail,
        CasesFooter,
    },
    watch: {
        $route () {
            this.CaseId = this.$route.params.id
            if(!this.CaseId) return
            this.getPageData()
        }
    },
    created () {
        this.CaseId = this.$route.params.id
        this.getPageData()
        this.getDetail()
    }, 
    mounted () {
    },
    methods: {
        //获取详情
        getDetail(){
              //this.CaseId
            this.$http.get('https://eartisanapplets.wsandos.com/api/index/case',{id:this.CaseId}, (res) => { 
                this.caseInfo= res.data
            })
        },
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        getPageData () {
            this.$http.get('home/index/m_getcase',{id:this.CaseId}, (res) => { 
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.topStyle = "background:url('"+this.$imgUrl+res.data.header[0].m_cgal.replace(/\\/g,'/')+"')"
                this.contactInfo = res.data.contact[0]
                // this.caseInfo = res.data.case
                this.$nextTick(()=>{
                    // this.$refs.newsRef.imgSwiper()
                    // this.$refs.teamRef.imgSwiper()
                })
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
    
</style>


// WEBPACK FOOTER //
// src/views/mobile/CaseDetail.vue